module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_stethscope-749bd51cc2a41e0b5bd8af3c688d790c.svg";